import React, { Fragment, useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import ReactGA from 'react-ga';
import { Button, Media, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { ACHIEVEMENT_DATA, MENU_NAVIGATION, SCREENS, USER_NOTIFICATIONS } from "../../../constants/constants";
import { useTranslation } from 'react-i18next';
import moment from "moment";

import closeImg from '../../../images/icons/close.png';
import defaultImage from '../../../images/Game/defaultImage.jpg';
import helpImg from '../../../images/icons/help2L.png';
import wheel from '../../../images/BonusPage/bonusu_rats_3_min.png';
import tournamentsIcon from '../../../images/icons/tournamentsL.png';
import fourPRoom from '../../../images/icons/4p_room.svg';
import threePRoom from '../../../images/icons/3p_room.svg';
import twoPRoom from '../../../images/icons/2p_room.svg';
import powerRanking from '../../../images/redesign/mobile/icons/power-ranking-menu-icon.svg'
import top from '../../../images/redesign/mobile/icons/top-menu-icon.svg'
import shop from '../../../images/icons/shoping_cart_large.png';
import { connect } from "react-redux";
import { setJoinTournamentIdTrigger, setOpenLuckyWheelHistoryTrigger } from "../../../actions/state";
import TournamentInfo from "./TournamentInfo";
import { clearUserNotifications, getGiftsHistory, getUserNotificationsLive, markAsReadUserNotifications, removeGift, removeUserNotification, setUserScreenViewNew, stopGetUserNotificationsLive } from "../../../actions/member";


const gift = 'https://firebasestorage.googleapis.com/v0/b/zole-app.appspot.com/o/gifts2%2Fcoffee.svg?alt=media&token=94f3b01f-7348-42ec-b43e-311da09a10b0';

const getAchievementImg = (achievement, claimedAchievementValue) => {
    const borders = ACHIEVEMENT_DATA[achievement].borders;
    
    let img;

    let imgKey = achievement;
    if (achievement === 'highestEarned') imgKey = 'balance';

    try {
        const index = claimedAchievementValue - 1;

        if (borders[index + 1]) {
            // eslint-disable-next-line
            img = require(`../../../images/Ach/${imgKey}_${borders[index]}_${borders[index + 1]}.png`);
        } else {
            // eslint-disable-next-line
            img = require(`../../../images/Ach/${imgKey}_${borders[index]}.png`);
        }
    } catch (e) {
        console.log(e);
    }

    return img;
}

const getAchievementName = (achievement, claimedAchievementValue, language, t) => {
    const translationKeys = ACHIEVEMENT_DATA[achievement].translationKeys[language];
    const borders = ACHIEVEMENT_DATA[achievement].borders;

    const index = claimedAchievementValue - 1;
    const nameKey = translationKeys[index] || translationKeys[translationKeys.length - 1];
    const name = t(`achievements:${nameKey}`);

    const val = borders[index] >= 1000 ? `${borders[index] / 1000}k` : borders[index];
    const hideNumber = (ACHIEVEMENT_DATA[achievement].dontShowValue === 'first' && index === 0) || ACHIEVEMENT_DATA[achievement].dontShowValue === 'all';
    const placeNumberAfterText = ACHIEVEMENT_DATA[achievement].numPlacement === 'after';

    return `${hideNumber || placeNumberAfterText ? '' : val} ${t(name)}${placeNumberAfterText ? ` ${val}` : ''}`;
}

const getAchievementReward = (achievement, claimedAchievementValue) => {
    const rewards = ACHIEVEMENT_DATA[achievement].rewards;
    const index = claimedAchievementValue - 1;
    return rewards[index];
}

function UserNotifications({
    toggle,
    isOpen,
    userNotifications,
    userNotificationsUnreadCount,
    history,
    notificationSettings,
    changeTab,
    getGiftsHistoryFunc,
    removeGiftFunc,
    fontMode,
    toggleSupport,
    setOpenLuckyWheelHistoryTriggerFunc,
    setJoinTournamentIdTriggerFunc,
    tournaments,
    setScreenViewNew,
    member,
    toggleBalanceHistory,
    getUserNotificationsLiveFunc,
    stopGetUserNotificationsLiveFunc,
    removeUserNotificationFunc,
    clearUserNotificationsFunc,
    markAsReadUserNotificationsFunc,
}) {
    const { t, i18n } = useTranslation(/*['common']*/);

    const [removeGiftModalOpen, setRemoveGiftModalOpen] = useState(false);
    const [removeGiftError, setRemoveGiftError] = useState(null);
    const [removeGiftSelected, setRemoveGiftSelected] = useState(null);

    const [tournamentInfoModalOpen, setTournamentInfoModalOpen] = useState(false);
    const [selectTournament, setSelectTournament] = useState(null);

    useEffect(() => {
        getUserNotificationsLiveFunc(member.uid);

        return () => {
            stopGetUserNotificationsLiveFunc(member.uid);
        };
    }, []);

    // const userNotifications = {
    //     id1: {
    //         notificationType: 'achievement',
    //         achievement: 'maxSuccessionLosses',
    //         claimedAchievementValue: 4, // index in border ? //for gamesPlayed and gamesWon it's NOT stored in claimedAchievements
    //         date: 1777384146169,
    //     },
    //     id2: {
    //         notificationType: 'friend',
    //         name: 'Mareks Zajacs',
    //         photo: 'https://i6.ifrype.com/profile/669/646/v1448899746/sm_2669646.jpg',// optional field
    //         date: 1777384146168,
    //     },
    //     id3: {
    //         notificationType: 'friendCoins',
    //         name: 'Mareks Zajacs',
    //         photo: 'https://i6.ifrype.com/profile/669/646/v1448899746/sm_2669646.jpg',// optional field
    //         coins: 999,
    //         date: 1777384146167,
    //     },
    //     id4: {
    //         notificationType: 'gift',
    //         name: 'Mareks Zajacs',
    //         giftId: '-Opg_dIHvL7XkN6IV3NG',
    //         image: 'https://firebasestorage.googleapis.com/v0/b/zole-app.appspot.com/o/gifts2%2Fcoffee.svg?alt=media&token=94f3b01f-7348-42ec-b43e-311da09a10b0',
    //         date: 1777384146166,
    //     },
    //     id5: {
    //         notificationType: 'supportMessage',
    //         date: 1777384146165
    //     },
    //     id6: {
    //         notificationType: 'luckyWheel',
    //         coins: -999,
    //         date: 1777384146164
    //     },
    //     id7: {
    //         notificationType: 'tournament',
    //         titleLV: 'Vakara Turnīrs: 29.04.2026',
    //         titleEN: 'Evening Tournament: 29.04.2026',
    //         titleRU: 'Вечерний Турнир: 29.04.2026',
    //         tournamentId: '-OrUgGbh1gHINZRrOUjr',
    //         date: 1777384146163
    //     },
    //     id8: {
    //         notificationType: 'roomComplete',
    //         roomId: '-OrxgJpx96M9mDN3m3iu',
    //         names: ['player name1', 'player name2'],
    //         coins: -999,
    //         points: -999,
    //         date: 1777384146162
    //     },
    //     id9: {
    //         notificationType: 'ignored',
    //         name: 'ignoredName',
    //         photo: 'https://i6.ifrype.com/profile/669/646/v1448899746/sm_2669646.jpg',// optional field
    //         date: 1777384146161
    //     },
    //     id10: {
    //         notificationType: 'powerRanking',
    //         sorting: 'best', // or worst
    //         category: 'rating',
    //         number: 2,
    //         date: 1777384146160
    //     },
    //     id11: {
    //         notificationType: 'top',
    //         category: 'points',
    //         date: 1777384146159
    //     },
    //     id12: {
    //         notificationType: 'adminCoins',
    //         coins: 999,
    //         date: 1777384146158
    //     },
    //     id13: {
    //         notificationType: 'purchase',
    //         name: 'item name',
    //         date: 1777384146157
    //     },
    //     id14: {
    //         notificationType: 'giftCode',
    //         coins: 999,
    //         date: 1777384146156
    //     },
    // };

    const changeTabWrapper = (tab) => {
        toggle();
        changeTab(tab);
    }

    const toggleSupportWrapper = () => {
        toggle();
        toggleSupport();
    }

    const toggleBalanceHistoryWrapper = () => {
        toggle();
        toggleBalanceHistory();
    }

    const openLuckyWheelHistory = () => {
        toggle();
        changeTabWrapper(MENU_NAVIGATION.bonusPage);
        setOpenLuckyWheelHistoryTriggerFunc(true);
    }

    const joinTournament = (tournamentId) => {
        toggle();
        changeTabWrapper(MENU_NAVIGATION.futureTournaments);
        setJoinTournamentIdTriggerFunc(tournamentId);

    }

    const openTournamentInfoModal = (selectId) => {
        toggle();
        setScreenViewNew(SCREENS.TOURNAMENTS.INFO);

        setTournamentInfoModalOpen(true);
        setSelectTournament({ ...tournaments.filter(tournament => tournament.id === selectId)[0] });
    }

    const openRoomResults = (roomId, roomPlayerCount) => {
        if (roomPlayerCount === 2) {
            history.push(`/student-zole/${roomId}`);
        } else {
            history.push(`/zole/${roomId}`);
        }
    }

    const startRemoveGift = (giftId) => {
        if (notificationSettings && notificationSettings.removeGift === false) {
            approveRemove(giftId);
        } else {
            setRemoveGiftSelected(giftId);
            setRemoveGiftModalOpen(true);
        }
    }

    const closeRemoveGiftModal = () => {
        setRemoveGiftSelected(null);
        setRemoveGiftModalOpen(false);
    }

    const closeRemoveGiftErrorModal = () => {
        setRemoveGiftError(null);
        setRemoveGiftModalOpen(false);
        setRemoveGiftSelected(null);
    }

    const buyMoney = () => {
        closeRemoveGiftErrorModal();
        changeTabWrapper(MENU_NAVIGATION.buyPageMoneyPacks);
    }

    const approveRemove = (passedGift) => {
        if (passedGift) {
            removeGiftFunc(passedGift, member.giftsHistory[passedGift]).then((res) => {
                if (res && res.data && res.data.status === 'success') {
                    getGiftsHistoryFunc();
            
                    ReactGA.event({
                        category: 'Menu',
                        action: 'Remove Gift',
                    });
                }
        
                if (res && res.data && (res.data.status === 'error' && res.data.message === 'low balance')) {
                    setRemoveGiftError('lowBalance');
                    setRemoveGiftModalOpen(false);
                    setRemoveGiftSelected(null);
                } else {
                    setRemoveGiftSelected(null);
                    setRemoveGiftModalOpen(false);
                }
          });
        } else if (removeGiftSelected) {
            removeGiftFunc(removeGiftSelected, member.giftsHistory[removeGiftSelected]).then((res) => {
                if (res && res.data && res.data.status === 'success') {
                    getGiftsHistoryFunc();
            
                    ReactGA.event({
                        category: 'Menu',
                        action: 'Remove Gift',
                    });
                }
        
                if (res && res.data && (res.data.status === 'error' && res.data.message === 'low balance')) {
                    setRemoveGiftError('lowBalance');
                    setRemoveGiftModalOpen(false);
                    setRemoveGiftSelected(null);
                } else {
                    setRemoveGiftSelected(null);
                    setRemoveGiftModalOpen(false);
                }
            });
        }
    }

    const markAsReadWrapper = () => {
        toggle();
        markAsReadUserNotificationsFunc();
    }

    const sortedNotifications = Object.entries(userNotifications)
        .sort(([, a], [, b]) => b.date - a.date);

    return (
        <Fragment>
            {isOpen && (
                <div className="user-notifications">
                    <div className="user-notifications-header">
                        <div className="user-notifications-header-title">
                            {t(`userNotifications:title`)}
                        </div>

                        <Media
                            src={closeImg}
                            className="notification-header-close"
                            onClick={toggle}
                            alt="X"
                        />
                    </div>

                    <div className="user-notifications-body old-design-scrollbar">

                        {sortedNotifications.length === 0 && (
                            <div className="user-notifications-new-body-empty">
                                {t(`userNotifications:empty`)}
                            </div>
                        )}

                        {sortedNotifications.map(([id, item]) => {

                            let notificationImg;
                            const notificationTitle = t(`userNotifications:${item.notificationType}.title`);
                            let notificationDescription;
                            let notificationButtons;


                            if (item.notificationType === USER_NOTIFICATIONS.achievement) {
                                notificationImg = getAchievementImg(item.achievement, item.claimedAchievementValue);

                                const achievementName = getAchievementName(item.achievement, item.claimedAchievementValue, i18n.language, t);
                                const achievementReward = getAchievementReward(item.achievement, item.claimedAchievementValue);

                                notificationDescription = t(`userNotifications:${item.notificationType}.description`, { achievementName, achievementReward });

                                notificationButtons = (
                                    <>
                                        <button
                                            className="user-notifications-body-item-bottom-buttons-button"
                                            onClick={() => changeTabWrapper(MENU_NAVIGATION.archievements)}
                                        >
                                            {t(`userNotifications:${item.notificationType}.buttonText`)}
                                        </button>
                                    </>
                                );
                            } else if (item.notificationType === USER_NOTIFICATIONS.friend) {
                                notificationImg = item.photo || defaultImage;
                                const name = item.name;

                                notificationDescription = t(`userNotifications:${item.notificationType}.description`, { name });

                                notificationButtons = (
                                    <>
                                        <button
                                            className="user-notifications-body-item-bottom-buttons-button"
                                            onClick={() => changeTabWrapper(MENU_NAVIGATION.friends)}
                                        >
                                            {t(`userNotifications:${item.notificationType}.buttonText`)}
                                        </button>
                                    </>
                                );
                            } else if (item.notificationType === USER_NOTIFICATIONS.friendCoins) {
                                notificationImg = item.photo || defaultImage;
                                const name = item.name;
                                const coins = item.coins;

                                notificationDescription = t(`userNotifications:${item.notificationType}.description`, { name, coins });

                                notificationButtons = (
                                    <>
                                        <button
                                            className="user-notifications-body-item-bottom-buttons-button"
                                            onClick={() => changeTabWrapper(MENU_NAVIGATION.friends)}
                                        >
                                            {t(`userNotifications:${item.notificationType}.buttonText`)}
                                        </button>
                                    </>
                                );
                            } else if (item.notificationType === USER_NOTIFICATIONS.gift) {
                                notificationImg = item.image;
                                const name = item.name;
                                const giftId = item.giftId;

                                notificationDescription = t(`userNotifications:${item.notificationType}.description`, { name });

                                notificationButtons = (
                                    <>
                                        <button
                                            className="user-notifications-body-item-bottom-buttons-button"
                                            onClick={() => changeTabWrapper(MENU_NAVIGATION.myInfo)}
                                        >
                                            {t(`userNotifications:${item.notificationType}.buttonText`)}
                                        </button>
                                        <button
                                            className="user-notifications-body-item-bottom-buttons-button"
                                            onClick={() => startRemoveGift(giftId)}
                                        >
                                            {t(`userNotifications:${item.notificationType}.buttonText2`)}
                                        </button>
                                    </>
                                );
                            } else if (item.notificationType === USER_NOTIFICATIONS.supportMessage) {
                                notificationImg = helpImg;

                                notificationDescription = t(`userNotifications:${item.notificationType}.description`);

                                notificationButtons = (
                                    <>
                                        <button
                                            className="user-notifications-body-item-bottom-buttons-button"
                                            onClick={() => toggleSupportWrapper()}
                                        >
                                            {t(`userNotifications:${item.notificationType}.buttonText`)}
                                        </button>
                                    </>
                                );
                            } else if (item.notificationType === USER_NOTIFICATIONS.luckyWheel) {
                                notificationImg = wheel;

                                const coinsWithSign = item.coins;
                                const coins = Math.abs(coinsWithSign);

                                notificationDescription = coins > 0
                                    ? t(`userNotifications:${item.notificationType}.description`, { coins })
                                    : t(`userNotifications:${item.notificationType}.description2`, { coins });

                                notificationButtons = (
                                    <>
                                        <button
                                            className="user-notifications-body-item-bottom-buttons-button"
                                            onClick={() => openLuckyWheelHistory()}
                                        >
                                            {t(`userNotifications:${item.notificationType}.buttonText`)}
                                        </button>
                                    </>
                                );
                            } else if (item.notificationType === USER_NOTIFICATIONS.tournament) {
                                notificationImg = tournamentsIcon;

                                const title = item[`title${i18n.language.toUpperCase()}`];
                                const tournamentId = item.tournamentId;

                                notificationDescription = t(`userNotifications:${item.notificationType}.description`, { title });

                                notificationButtons = (
                                    <>
                                        <button
                                            className="user-notifications-body-item-bottom-buttons-button"
                                            onClick={() => openTournamentInfoModal(tournamentId)}
                                        >
                                            {t(`userNotifications:${item.notificationType}.buttonText`)}
                                        </button>
                                        <button
                                            className="user-notifications-body-item-bottom-buttons-button"
                                            onClick={() => joinTournament(tournamentId)}
                                        >
                                            {t(`userNotifications:${item.notificationType}.buttonText2`)}
                                        </button>
                                    </>
                                );
                            } else if (item.notificationType === USER_NOTIFICATIONS.roomComplete) {
                                notificationImg = item.names.length === 3
                                    ? threePRoom
                                    : item.names.length === 4
                                        ? fourPRoom
                                        : twoPRoom;

                                const names = item.names.join(', ');
                                const coinsWithSign = item.coins;
                                const pointsWithSign = item.points;
                                const coins = Math.abs(coinsWithSign);
                                const points = Math.abs(pointsWithSign);
                                const roomId = item.roomId;
                                const roomPlayerCount = item.names.length;

                                notificationDescription = coinsWithSign > 0
                                    ? t(`userNotifications:${item.notificationType}.description`, { names, coins, points })
                                    : t(`userNotifications:${item.notificationType}.description2`, { names, coins, points });

                                notificationButtons = (
                                    <>
                                        <button
                                            className="user-notifications-body-item-bottom-buttons-button"
                                            onClick={() => openRoomResults(roomId, roomPlayerCount)}
                                        >
                                            {t(`userNotifications:${item.notificationType}.buttonText`)}
                                        </button>
                                    </>
                                );
                            } else if (item.notificationType === USER_NOTIFICATIONS.ignored) {
                                notificationImg = item.photo || defaultImage;

                                const name = item.name;

                                notificationDescription = t(`userNotifications:${item.notificationType}.description`, { name });

                                notificationButtons = (
                                    <>
                                        <button
                                            className="user-notifications-body-item-bottom-buttons-button"
                                            onClick={() => changeTabWrapper(MENU_NAVIGATION.ignoredUsers)}
                                        >
                                            {t(`userNotifications:${item.notificationType}.buttonText`)}
                                        </button>
                                    </>
                                );
                            } else if (item.notificationType === USER_NOTIFICATIONS.powerRanking) {
                                notificationImg = powerRanking;

                                const sorting = item.sorting;
                                const number = item.number;
                                const category = item.category;

                                notificationDescription = sorting === 'best'
                                    ? t(`userNotifications:${item.notificationType}.description`, { number, category })
                                    : t(`userNotifications:${item.notificationType}.description2`, { number, category })


                                notificationButtons = (
                                    <>
                                        <button
                                            className="user-notifications-body-item-bottom-buttons-button"
                                            onClick={() => changeTabWrapper(MENU_NAVIGATION.powerRankings)}
                                        >
                                            {t(`userNotifications:${item.notificationType}.buttonText`)}
                                        </button>
                                    </>
                                );
                            } else if (item.notificationType === USER_NOTIFICATIONS.top) {
                                notificationImg = top;

                                const category = item.category;

                                notificationDescription = t(`userNotifications:${item.notificationType}.description`, { category });

                                notificationButtons = (
                                    <>
                                        <button
                                            className="user-notifications-body-item-bottom-buttons-button"
                                            onClick={() => changeTabWrapper(MENU_NAVIGATION.top)}
                                        >
                                            {t(`userNotifications:${item.notificationType}.buttonText`)}
                                        </button>
                                    </>
                                );
                            } else if (item.notificationType === USER_NOTIFICATIONS.adminCoins) {
                                notificationImg = helpImg;

                                const coins = item.coins;

                                notificationDescription = t(`userNotifications:${item.notificationType}.description`, { coins });

                                notificationButtons = (
                                    <>
                                        <button
                                            className="user-notifications-body-item-bottom-buttons-button"
                                            onClick={() => toggleSupportWrapper()}
                                        >
                                            {t(`userNotifications:${item.notificationType}.buttonText`)}
                                        </button>
                                        <button
                                            className="user-notifications-body-item-bottom-buttons-button"
                                            onClick={() => toggleBalanceHistoryWrapper()}
                                        >
                                            {t(`userNotifications:${item.notificationType}.buttonText2`)}
                                        </button>
                                    </>
                                );
                            } else if (item.notificationType === USER_NOTIFICATIONS.purchase) {
                                notificationImg = shop;

                                const name = item.name;

                                notificationDescription = t(`userNotifications:${item.notificationType}.description`, { name });

                                notificationButtons = (
                                    <>
                                        <button
                                            className="user-notifications-body-item-bottom-buttons-button"
                                            onClick={() => changeTabWrapper(MENU_NAVIGATION.buyPageHistory)}
                                        >
                                            {t(`userNotifications:${item.notificationType}.buttonText`)}
                                        </button>
                                    </>
                                );
                            } else if (item.notificationType === USER_NOTIFICATIONS.giftCode) {
                                notificationImg = gift;

                                const coins = item.coins;

                                notificationDescription = t(`userNotifications:${item.notificationType}.description`, { coins });

                                notificationButtons = (
                                    <>
                                        <button
                                            className="user-notifications-body-item-bottom-buttons-button"
                                            onClick={() => toggleBalanceHistoryWrapper()}
                                        >
                                            {t(`userNotifications:${item.notificationType}.buttonText`)}
                                        </button>
                                    </>
                                );
                            }

                            return (
                                <div key={id} className="user-notifications-body-item">
                                    {!item.read && <div className="user-notifications-body-item-unread" />}
                                    <div className="user-notifications-body-item-top">
                                        <Media src={notificationImg} className="user-notifications-body-item-top-img" />
                                        <div className="user-notifications-body-item-top-content">
                                            <div className="user-notifications-body-item-top-content-title">
                                                
                                                <span className="user-notifications-body-item-top-content-title-text">
                                                    {notificationTitle}
                                                </span>

                                                <div
                                                    className="user-notifications-body-item-top-content-title-delete"
                                                    onClick={() => removeUserNotificationFunc(id)}
                                                >
                                                    X
                                                </div>

                                            </div>

                                            <span className="user-notifications-body-item-top-content-description">
                                                {notificationDescription}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="user-notifications-body-item-bottom">
                                        <span>{moment(item.date).format('DD-MM-YYYY HH:mm')}</span>

                                        <div className="user-notifications-body-item-bottom-buttons">
                                            {notificationButtons}
                                        </div>
                                        
                                    </div>
                                </div>
                            )
                        })}
                        
                    </div>

                    <div className="user-notifications-footer">
                        <button
                            className="user-notifications-footer-button"
                            onClick={() => clearUserNotificationsFunc()}
                            disabled={sortedNotifications.length === 0}
                        >
                            {t(`userNotifications:clearAll`)}
                        </button>
                        <button
                            className="user-notifications-footer-button"
                            onClick={() => markAsReadWrapper()}
                            disabled={userNotificationsUnreadCount === 0}
                        >
                            {t(`userNotifications:markAll`)}
                        </button>
                    </div>
                    
                </div>
            )}


            <Modal container={'div > div'} isOpen={removeGiftModalOpen} toggle={() => closeRemoveGiftModal()} className={`notification old-modal root-font-${fontMode}`}>
                <ModalHeader
                    className="notification-header"
                    close={
                        <Media src={closeImg} className="notification-header-close" alt="X" onClick={() => closeRemoveGiftModal()} />
                    }
                >
                    {t('common:home.confirm')}
                </ModalHeader>
                <ModalBody>
                    {t('common:myInfo.deleteGiftMessage')}
                </ModalBody>
                <ModalFooter className="notification-footer">
                    <Button type="button" className="btn notification-footer-button" color="link" onClick={() => approveRemove()}>
                        {t('common:common.yes')}
                    </Button>
                    <Button type="button" className="btn notification-footer-button" color="link" onClick={() => closeRemoveGiftModal()}>
                        {t('common:common.no')}
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal container={'div > div'} isOpen={!!removeGiftError} toggle={() => closeRemoveGiftErrorModal()} className={`notification old-modal root-font-${fontMode}`}>
                <ModalHeader
                    className="notification-header"
                    close={
                        <Media src={closeImg} className="notification-header-close" alt="X" onClick={() => closeRemoveGiftErrorModal()} />
                    }
                >
                    {t('common:home.notifications')}
                </ModalHeader>
                <ModalBody>
                    {removeGiftError === 'lowBalance'
                        ? t('common:myInfo.notEnoughMoneyRemoveGift')
                        : t('common:myInfo.deleteGiftError')
                    }
                </ModalBody>
                <ModalFooter className="notification-footer">
                    {removeGiftError === 'lowBalance' ? (
                        <Button className="notification-footer-button" color="link" onClick={() => buyMoney()}>
                            {t('common:myInfo.buyMoney')}
                        </Button>
                    ) : (null)}
                    <Button type="button" className="btn notification-footer-button" color="link" onClick={() => closeRemoveGiftErrorModal()}>
                        {t('common:common.close')}
                    </Button>
                </ModalFooter>
            </Modal>

            <TournamentInfo
                tournamentInfoModalOpen={tournamentInfoModalOpen}
                closeTournamentInfoModal={() => setTournamentInfoModalOpen(false)}
                selectTournament={selectTournament}
                fontMode={fontMode}
            />
        </Fragment>
    );
}

const mapStateToProps = state => ({
    userNotifications: state.member.userNotifications,
    userNotificationsUnreadCount: state.member.userNotificationsUnreadCount,
    registeredTournament: state.member.registeredTournament,
    tournaments: (state.tournaments && state.tournaments.tournaments) ? state.tournaments.tournaments : [],
    member: state.member,
});

const mapDispatchToProps = {
    setOpenLuckyWheelHistoryTriggerFunc: setOpenLuckyWheelHistoryTrigger,
    setJoinTournamentIdTriggerFunc: setJoinTournamentIdTrigger,
    setScreenViewNew: setUserScreenViewNew,
    getUserNotificationsLiveFunc: getUserNotificationsLive,
    stopGetUserNotificationsLiveFunc: stopGetUserNotificationsLive,

    removeUserNotificationFunc: removeUserNotification,
    clearUserNotificationsFunc: clearUserNotifications,
    markAsReadUserNotificationsFunc: markAsReadUserNotifications,

    getGiftsHistoryFunc: getGiftsHistory,
    removeGiftFunc: removeGift,
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(UserNotifications)
);